import { render, staticRenderFns } from "./AddIssuer.vue?vue&type=template&id=510f005e"
import script from "./AddIssuer.vue?vue&type=script&lang=js"
export * from "./AddIssuer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports